/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  CREATE_PROJECT,
  getProjectListUrl,
  getProjectRouterPath,
  READ_PROJECT,
  READ_PROJECTS_LIST,
  UPDATE_PROJECT,
  useProjectRoute,
} from 'domain/shared/project';
import ProjectList from 'domain/projects/project/List';
import { CreateProject, UpdateProject } from 'domain/projects/project/createupdate';
import ViewProject from 'domain/projects/project/Show';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import ProjectStatusesList from './statuses/statusList';
import { READ_PROJECT_STATUS_LIST } from './statuses/ProjectStatusesService';
import ProjectContext from './ProjectContext';
import { READ_PROJECT_REPORTS_LIST } from './weeklyreports/ProjectWeeklyReportService';
import ShowProject from './statuses/shared/ShowProject';
import ProjectWeeklyReportRouter from './weeklyreports/ProjectWeeklyReportRouter';
import { READ_PROJECT_DASHBOARD } from './dashboard/ProjectDashboardService';
import ProjectDashboardRouter from './dashboard/ProjectDashboardRouter';
import { CREATE_REDMINE_PROJECT } from './redmineproject/redmineProjectService';
import CreateRedmineProject from './redmineproject/createupdate/Create';
import ProjectsWBSDashboardList from './ProjectsWBSDashboard/ProjectsWBSDashboardList';

const ProjectRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createProjectRoute,
    updateRoute,
    weeklyReportRoute,
    dashboardRoute,
    timelineRoute,
    redmineProjectRoute,
    wbsDashboardProjectRoute,
  } = useProjectRoute();

  return (
    <ProtectedRouter basePath={getProjectListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_PROJECTS_LIST}>
              <ProjectList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createProjectRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_PROJECT}>
              <CreateProject />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <ProjectContext permissionToCheck={READ_PROJECT}>
              <ViewProject />
            </ProjectContext>
          }
        />

        <Route
          path={updateRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={UPDATE_PROJECT}>
              <UpdateProject />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={timelineRoute}
          element={
            <ProjectContext permissionToCheck={READ_PROJECT_STATUS_LIST}>
              <ProjectStatusesList />
            </ProjectContext>
          }
        />

        <Route
          path={weeklyReportRoute}
          element={
            <ProjectContext permissionToCheck={READ_PROJECT_REPORTS_LIST}>
              <ShowProject>
                <ProjectWeeklyReportRouter />
              </ShowProject>
            </ProjectContext>
          }
        />

        <Route
          path={dashboardRoute}
          element={
            <ProjectContext permissionToCheck={READ_PROJECT_DASHBOARD}>
              <ShowProject>
                <ProjectDashboardRouter />
              </ShowProject>
            </ProjectContext>
          }
        />

        <Route
          path={redmineProjectRoute}
          element={
            <ProjectContext permissionToCheck={CREATE_REDMINE_PROJECT}>
              <CreateRedmineProject />
            </ProjectContext>
          }
        />

        {/* TODO Use READ_WBS permission when BE is ready */}
        <Route
          path={wbsDashboardProjectRoute}
          element={
            <ProjectContext permissionToCheck={READ_PROJECT_DASHBOARD}>
              <ProjectsWBSDashboardList />
            </ProjectContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ProjectRouter.getRouterPath = getProjectRouterPath;

export default ProjectRouter;
